import React from "react";
import { Box, Container, Typography, Button, Stack } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";

const CTASection = ({ onRequestDemo }) => {
    const navigate = useNavigate();
    return (
        <Box
            sx={{
                py: { xs: 2, md: 1 },
                backgroundColor: "#F9FBFF",
                fontFamily: "'Poppins', sans-serif",
            }}
        >
            <Container maxWidth="xl">
                <Box
                    data-aos="zoom-in"
                    sx={{
                        background: "linear-gradient(180deg, #133481 0%, #4f685e 100%)", // Dark navy gradient
                        borderRadius: "32px",
                        overflow: "hidden",
                        position: "relative",
                        py: { xs: 8, md: 6 },
                        px: { xs: 4, md: 6 },
                        textAlign: "center",
                        boxShadow: "0 20px 40px -4px rgba(0, 0, 0, 0.1)",
                    }}
                >
                    {/* Content Container */}
                    <Box sx={{ position: "relative", zIndex: 1, maxWidth: "800px", mx: "auto" }}>
                        <Typography
                            variant="h2"
                            sx={{
                                fontWeight: 700,
                                color: "#FFFFFF",
                                fontSize: { xs: "32px", md: "56px" },
                                mb: 3,
                                fontFamily: "'Poppins', sans-serif",
                                lineHeight: 1.1,
                            }}
                        >
                            Ready to Transform Your{" "}
                            <Box component="span" sx={{ color: "#FF6B00" }}>
                                Recruiting?
                            </Box>
                        </Typography>
                        <Typography
                            sx={{
                                color: "#94A3B8",
                                fontSize: { xs: "16px", md: "20px" },
                                mb: 6,
                                fontFamily: "'Poppins', sans-serif",
                                px: { xs: 2, md: 8 },
                            }}
                        >
                            Join thousands of recruiters and consultants who are already using
                            Benchsales to connect and grow.
                        </Typography>

                        <Stack
                            direction={{ xs: "column", sm: "row" }}
                            spacing={3}
                            justifyContent="center"
                            alignItems="center"
                            sx={{ mb: 4 }}
                        >
                            <Button
                                variant="contained"
                                endIcon={<ArrowForwardIcon />}
                                onClick={() => navigate("/login")}
                                sx={{
                                    backgroundColor: "#FF6B00",
                                    color: "#FFFFFF",
                                    fontSize: "16px",
                                    fontWeight: 500,
                                    py: 1.5,
                                    px: 4,
                                    borderRadius: "8px",
                                    textTransform: "none",
                                    fontFamily: "'Poppins', sans-serif",
                                    boxShadow: "0 4px 14px 0 rgba(255, 107, 0, 0.39)",
                                    "&:hover": {
                                        backgroundColor: "#E65100",
                                    },
                                    minWidth: "200px",
                                }}
                            >
                                Get Started
                            </Button>
                            <Button
                                variant="outlined"
                                onClick={onRequestDemo}
                                sx={{
                                    color: "#FFFFFF",
                                    borderColor: "rgba(255, 255, 255, 0.2)",
                                    fontSize: "16px",
                                    fontWeight: 500,
                                    py: 1.5,
                                    px: 4,
                                    borderRadius: "8px",
                                    textTransform: "none",
                                    fontFamily: "'Poppins', sans-serif",
                                    "&:hover": {
                                        borderColor: "#FFFFFF",
                                        backgroundColor: "rgba(255, 255, 255, 0.05)",
                                    },
                                    minWidth: "200px",
                                }}
                            >
                                Schedule a Demo
                            </Button>
                        </Stack>


                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default CTASection;
